import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarCollapsed: false,
    insufficientCreditsModalOpen: false,
  },
  reducers: {
    setSidebarCollapsed(state, action) {
      state.sidebarCollapsed = action.payload;
    },
    showInsufficientCreditsModal(state) {
      state.insufficientCreditsModalOpen = true;
    },
    hideInsufficientCreditsModal(state) {
      state.insufficientCreditsModalOpen = false;
    },
  },
});

export const {
  setSidebarCollapsed,
  showInsufficientCreditsModal,
  hideInsufficientCreditsModal,
} = uiSlice.actions;
export default uiSlice.reducer;
